import { Box } from "@mui/material";

const FileIcon = ({ fileType }: { fileType: string }) => {
  const mediaIcon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="16" height="16" rx="3" fill="white" />
      <path
        d="M6.63781 11.6036L4.45435 15.2428C4.25439 15.576 4.49445 16 4.88309 16H15.191C15.5627 16 15.8044 15.6088 15.6382 15.2764L12.9073 9.81468C12.7309 9.46179 12.2344 9.44272 12.0314 9.78104L9.86219 13.3964C9.6851 13.6915 9.26969 13.7236 9.04933 13.4592L7.45067 11.5408C7.23031 11.2764 6.8149 11.3085 6.63781 11.6036Z"
        fill="#668D3E"
      />
    </svg>
  );

  const pdfIcon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 3C2 1.89543 2.89543 1 4 1H12.1716C12.702 1 13.2107 1.21071 13.5858 1.58579L17.4142 5.41421C17.7893 5.78929 18 6.29799 18 6.82843V17C18 18.1046 17.1046 19 16 19H4C2.89543 19 2 18.1046 2 17V3Z"
        fill="white"
      />
      <path
        d="M5 6.835C5 6.37384 5.37384 6 5.835 6H8.165C8.62616 6 9 6.37384 9 6.835C9 7.29616 8.62616 7.67 8.165 7.67H5.835C5.37384 7.67 5 7.29616 5 6.835Z"
        fill="#DA3E33"
      />
      <rect x="5" y="10" width="10" height="1.67" rx="0.835" fill="#DA3E33" />
      <rect x="5" y="14" width="10" height="1.67" rx="0.835" fill="#DA3E33" />
      <path
        d="M12.5 3V5.5C12.5 6.05228 12.9477 6.5 13.5 6.5H16"
        stroke="#DA3E33"
        stroke-width="1.67"
        stroke-linecap="round"
      />
    </svg>
  );

  const mediaFileTypes = [
    ".jpg",
    ".jpeg",
    ".png",
    "image/jpeg",
    "image/jpg",
    "image/png",
  ];

  const isMediaFile = mediaFileTypes.includes(fileType);

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        p: theme.nawy.spacing.xs,
        borderRadius: theme.nawy.radius.lg,
        backgroundColor:
          theme.nawy.colors.semantic.indicator[isMediaFile ? "green" : "red"],
        width: "36",
        height: "36",
      })}
    >
      {isMediaFile ? mediaIcon : pdfIcon}
    </Box>
  );
};

export default FileIcon;
